export default "__VITE_ASSET__D3XfZJiZ__"